import axios from "axios";

const TOKEN_KEY = "emk-auth-token";

const api = axios.create({
  baseURL: "/api",
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const checkHealth = () => api.get("/health");

// Kimlik doğrulama
export const login = (kullaniciAdi, sifre) =>
  api.post("/auth/login", { kullanici_adi: kullaniciAdi, sifre });
export const checkSession = () => api.get("/auth/me");
export const logout = () => api.post("/auth/logout");
export const changePassword = (kullaniciAdi, eskiSifre, yeniSifre) =>
  api.post("/auth/change-password", { kullanici_adi: kullaniciAdi, eski_sifre: eskiSifre, yeni_sifre: yeniSifre });
export const listTables = () => api.get("/data/tables");
export const getTableData = (schema, table, limit = 100, offset = 0) =>
  api.get(`/data/table/${schema}/${table}`, { params: { limit, offset } });
export const getTableSummary = (schema, table) =>
  api.get(`/data/summary/${schema}/${table}`);
export const runQuery = (sql) => api.post("/data/query", { sql });
export const runProcedure = (name) => api.post(`/data/procedure/${name}`, {}, { timeout: 300000 });
export const getSozlesmeler = () => api.get("/contracts/");
export const addSozlesme = (data) => api.post("/contracts/", data);
export const deleteSozlesme = (id) => api.delete(`/contracts/${id}`);
export const getAylikRapor = (yil, ay) => api.get(`/contracts/rapor?yil=${yil}&ay=${ay}`);
export const toggleFatura = (data) => api.post("/contracts/rapor/toggle", data);
export const getCariListesi = () => api.get("/contracts/cari");
export const getSiparisler = (cariKodu) => api.get(`/contracts/siparisler/${encodeURIComponent(cariKodu)}`);
export const sendCariEkstreMail = (cariKodu, cariIsmi, toEmail, ccEmail, baslangicTarihi, bitisTarihi, faturaDetayGoster) =>
  api.post("/contracts/cari/ekstre-mail", null, {
    params: {
      cari_kodu: cariKodu, cari_isim: cariIsmi, to_email: toEmail, cc_email: ccEmail || undefined,
      baslangic_tarihi: baslangicTarihi || undefined, bitis_tarihi: bitisTarihi || undefined,
      fatura_detay_goster: !!faturaDetayGoster,
    },
  });
export const getCariEkstrePdf = (cariKodu, cariIsmi, baslangicTarihi, bitisTarihi, faturaDetayGoster) =>
  api.get("/contracts/cari/ekstre-pdf", {
    responseType: "blob",
    params: {
      cari_kodu: cariKodu, cari_isim: cariIsmi,
      baslangic_tarihi: baslangicTarihi || undefined, bitis_tarihi: bitisTarihi || undefined,
      fatura_detay_goster: !!faturaDetayGoster,
    },
  });

// Stok Gelir/Gider (EMW_STOK_GC)
export const getStokGC = (params = {}) => api.get("/stok-gc/", { params });
export const getStokGCOzet = (params = {}) => api.get("/stok-gc/ozet", { params });
export const getStokListesi = (search = "") => api.get("/stok-gc/stoklar", { params: { search: search || undefined } });
export const getStokGCYillar = () => api.get("/stok-gc/yillar");
export const getStokGCOzetStok = (stokKodu, yillar = [], aylar = []) =>
  api.get("/stok-gc/ozet-stok", {
    params: {
      stok_kodu: stokKodu,
      yil: yillar.length ? yillar.join(",") : undefined,
      ay: aylar.length ? aylar.join(",") : undefined,
    },
  });

// CRM
export const getCrmSektorler = () => api.get("/crm/sektorler");
export const addCrmSektor = (ad) => api.post("/crm/sektorler", { ad });
export const deleteCrmSektor = (id) => api.delete(`/crm/sektorler/${id}`);

export const getCrmFirmalar = () => api.get("/crm/firmalar");
export const addCrmFirma = (data) => api.post("/crm/firmalar", data);
export const updateCrmFirma = (id, data) => api.put(`/crm/firmalar/${id}`, data);
export const deleteCrmFirma = (id) => api.delete(`/crm/firmalar/${id}`);

export const getCrmKisiler = (params = {}) => api.get("/crm/kisiler", { params });
export const addCrmKisi = (data) => api.post("/crm/kisiler", data);
export const updateCrmKisi = (id, data) => api.put(`/crm/kisiler/${id}`, data);
export const deleteCrmKisi = (id) => api.delete(`/crm/kisiler/${id}`);

export const getCrmFirsatlar = (params = {}) => api.get("/crm/firsatlar", { params });
export const addCrmFirsat = (data) => api.post("/crm/firsatlar", data);
export const updateCrmFirsat = (id, data) => api.put(`/crm/firsatlar/${id}`, data);
export const updateCrmFirsatAsama = (id, asama) => api.patch(`/crm/firsatlar/${id}/asama`, { asama });
export const deleteCrmFirsat = (id) => api.delete(`/crm/firsatlar/${id}`);

export const getCrmAktiviteler = (params = {}) => api.get("/crm/aktiviteler", { params });
export const addCrmAktivite = (data) => api.post("/crm/aktiviteler", data);
export const toggleCrmAktiviteTamamla = (id) => api.patch(`/crm/aktiviteler/${id}/tamamla`);
export const deleteCrmAktivite = (id) => api.delete(`/crm/aktiviteler/${id}`);

export const getCrmTeklifler = () => api.get("/crm/teklifler");
export const getCrmTeklifDetay = (id) => api.get(`/crm/teklifler/${id}`);
export const getCrmTeklifNetsisDetay = (fatirsNo) => api.get(`/crm/teklifler/netsis/${fatirsNo}`);
export const addCrmTeklif = (data) => api.post("/crm/teklifler", data);
export const updateCrmTeklif = (id, data) => api.put(`/crm/teklifler/${id}`, data);
export const updateCrmTeklifDurum = (id, durum) => api.patch(`/crm/teklifler/${id}/durum`, { durum });
export const deleteCrmTeklif = (id) => api.delete(`/crm/teklifler/${id}`);
export const sendCrmTeklifToNetsis = (id) => api.post(`/crm/teklifler/${id}/netsis-gonder`, {}, { timeout: 60000 });
export const getCrmTeklifPdf = (id) => api.get(`/crm/teklifler/${id}/pdf`, { responseType: "blob" });
export const getCrmTeklifNetsisPdf = (fatirsNo) => api.get(`/crm/teklifler/netsis/${fatirsNo}/pdf`, { responseType: "blob" });

export const getCrmStoklar = () => api.get("/crm/stoklar");
export const getCrmPlasiyerler = () => api.get("/crm/plasiyerler");

export const getCrmDashboard = () => api.get("/crm/dashboard");

// Cubicl entegrasyonu
export const getCubiclGroups = (params = {}) => api.get("/cubicl/groups", { params });
export const getCubiclTasks = (groupId, params = {}) =>
  api.get("/cubicl/tasks", { params: { group: groupId, ...params } });
export const updateCubiclTaskState = (taskId, value) =>
  api.put(`/cubicl/tasks/${taskId}/state`, { value });
export const getCubiclUsers = (ids) => api.get("/cubicl/users", { params: { ids: ids.join(",") } });
export const getCubiclTaskActivities = (taskId) => api.get(`/cubicl/tasks/${taskId}/activities`);
